<template>
    <div class="fd-com-page">
        <ac-title-bar
            title="解保申请"
            @back="back">
            <div>(<span v-text="total"></span>)</div>
        </ac-title-bar>
        <ul class="fd-com-tab">
            <li
                class="fd-item"
                :class="{'fd-active': currentTabNav === item.id}"
                v-for="(item, index) in tabNavList"
                :key="index"
                @click="changeTabNav(item)">
                {{ item.name }}
            </li>
        </ul>
        <div class="fd-com-search">
            <van-search
                placeholder="输入申请编号/申请人/申请法院"
                v-model="keyWord"
                @search="onSearch">
            </van-search>
            <van-icon class="fd-com-btn-refresh" name="replay" @click="refresh"/>
        </div>
        <div class="fd-com-nodata" v-if="total === 0" @load="loadData">
            暂无数据
        </div>
        <van-list
            class="fd-com-card-list"
            v-else
            v-model="loading"
            :finished="finished"
            :finished-text="loading ? '加载中...' : '没有更多了'"
            @load="loadData">
            <div
                class="fd-com-card"
                v-for="(item,index) of list"
                :key="index"
                @click.stop="goDetail(item.cId, item.btnList, item.cZt)">
                <h3 class="fd-com-card-title">
                    申请人：{{ item.cSqrmcs || '--' }}
                    <van-tag v-if="item.cZt === '待提交'" type="warning" :plain="false">
                        {{ item.cZt }}
                    </van-tag>
                    <van-tag v-else-if="item.cZt === '审查完成'" type="success" :plain="false">
                        {{ item.cZt }}
                    </van-tag>
                    <van-tag v-else-if="item.cZt === '审核不通过'" type="danger" :plain="false">
                        {{ item.cZt }}
                    </van-tag>
                    <van-tag v-else-if="item.cZt === '已取消'" :plain="false">
                        {{ item.cZt }}
                    </van-tag>
                    <van-tag v-else type="info" :plain="false">
                        {{ item.cZt }}
                    </van-tag>
                </h3>
                <ul class="fd-com-card-info">
                    <li>
                        <span class="fd-com-label">解保编号</span>
                        <span class="fd-com-content">{{ item.cSqbh ? item.cSqbh : '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请法院</span>
                        <span class="fd-com-content">{{ item.cSqfymc || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">案号</span>
                        <span class="fd-com-content">{{ item.cAh || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">申请日期</span>
                        <span class="fd-com-content">{{ item.dtCreatetime || '--' }}</span>
                    </li>
                    <li>
                        <span class="fd-com-label">解保事由</span>
                        <span class="fd-com-content">{{ item.cJcbqsy || '--' }}</span>
                    </li>
                </ul>
                <div
                    class="fd-com-card-bottom"
                    v-if="item.btnList.includes(btnType.SC_BUTTON) || item.btnList.includes(btnType.BJ_BUTTON)">
                    <van-button
                        v-if="item.btnList.includes(btnType.SC_BUTTON)"
                        class="fd-com-card-btn"
                        @click="onBtnClick(btnType.SC_BUTTON, item.cId)">
                        删除
                    </van-button>
                    <van-button
                        v-if="item.btnList.includes(btnType.BJ_BUTTON)"
                        class="fd-com-card-btn"
                        @click="onBtnClick(btnType.BJ_BUTTON, item.cId, item.cBqid, item.nBqlx)">
                        编辑
                    </van-button>
                </div>
            </div>
        </van-list>
    </div>
</template>

<script>
// 标题栏
import acTitleBar from "@/components/app/title-bar/index.vue";
import { Dialog } from "vant";
import { typeFysx, typeJcbqsy, typeJcbqZt, typeSqxbyy } from "@/filters/index";
import { btnType } from "@/utils/consts";
export default {
  data() {
    return {
      active: 0,
      keyWord: "", // 搜索关键字
      total: 0, // 保全总数
      list: [],
      loading: false, // 列表加载状态
      finished: false, // 是否列表全部加载完成
      page: 0, // 页码
      size: 10, // 每页尺寸, 固定不会改变
      btnType: btnType,
      smallPro: "",
        // 嵌入在线服务新增——顶部tab导航数据
        tabNavList: [
            {id: 'bqsq', name: '保全申请'},
            {id: 'fysq', name: '复议申请'},
            {id: 'jbsq', name: '解保申请'},
            {id: 'xbsq', name: '续保申请'}
        ],
        // 嵌入在线服务新增——当前tab导航标识
        currentTabNav: 'jbsq'
    };
  },
  components: {
    acTitleBar,
  },
  computed: {
    isShowBtn() {
      return function (power, btnCode) {
        return power
          ? power.split(",").indexOf(btnCode) > -1
            ? true
            : false
          : false;
      };
    },
  },
  methods: {

    /**
     * @function
     * @description 点击顶部tab导航
     * @param {*} item 当前点击对象数据
     * @return {undefined} 无返回值
     */
    changeTabNav(item) {
        this.currentTabNav = item.id;
        switch (this.currentTabNav) {
            // 保全申请
            case 'bqsq':
                this.$router.push("/home/myPreservation");
                break;
            // 复议申请
            case 'fysq':
                this.$router.push("/home/myReconsider");
                break;
            // 解保申请
            case 'jbsq':
                this.$router.push("/home/myRelievPreservation");
                break;
            // 续保申请
            case 'xbsq':
                this.$router.push("/home/myContinuationPreservation");
                break;
            default:
                break;
        }
    },

    tagType(type) {
      let name = "";
      this.codeList_811000.find((item) => {
        if (item.code === type) {
          name = item.name;
        }
      });
      return name;
    },
    // 返回事件
    back() {
      // 返回到我的申请里面
      this.$router.push("/home/myApply");
    },
    //刷新页面
    refresh() {
      window.location.reload();
    },
    //跳转详情
    goDetail(Id, showBtn, cZt) {
      // if (this.isShowBtn(showBtn, '14') && cZt !== '1') {
      if (showBtn.includes(14) && cZt !== "待提交") {
        this.$router.push({
          path: "/relievePreservationDetail",
          query: {
            // 复议id
            cId: Id,
          },
        });
      }
    },
    timeFormat(currentTime) {
      // 时间格式化 2019-09-08
      let time = new Date(currentTime);
      let year = time.getFullYear();
      let month = this.showTime(time.getMonth() + 1);
      let day = this.showTime(time.getDate());
      return year + "-" + month + "-" + day;
    },
    // 封装一个不够两位数就补零的函数
    showTime(t) {
      let time;
      time = t >= 10 ? t : "0" + t;
      return time;
    },
    getCode811000() {
      this.$axios.get("ssbq/api/code?codetype=811000").then((res) => {
        console.log(res);
      });
    },
    loadData() {
      // 解除保全
      this.loading = true;
      this.$axios
        .get(
          "ssbq/api/ssbq/jc/yzwlist?page=" +
            ++this.page +
            "&rows=" +
            this.size +
            "&searchValue=" +
            encodeURI(this.keyWord) +
            "&ly=2"
        )
        .then((res) => {
          let data = res.data;
          this.total = data.total;
          let listData = data.list;
          // this.list = data.list;
          // this.list.map(item => {
          //     item.dtCreatetime = this.timeFormat(item.dtCreatetime);
          //     item.cZt = typeJcbqZt(item.cZt)
          //     item.cJcbqsy = typeJcbqsy(item.cJcbqsy)
          //     item.btnList = item.showBtn.split(",").map(Number);
          // })
          for (let item of listData) {
            let temp = {
              cId: item.cId,
              cSqrmcs: item.cSqrmcs, // 申请人
              cSqbh: item.cSqbh,
              cSqfymc: item.cSqfymc,
              cAh: item.cAh,
              cZt: typeJcbqZt(item.cZt),
              dtCreatetime: this.timeFormat(item.dtCreatetime),
              cJcbqsy: typeJcbqsy(item.cJcbqsy),
              cBqid: item.cBqid,
              nBqlx: item.nBqlx,
              btnList: [], // 要展示的按钮
            };
            if (item.showBtn) {
              temp.btnList = item.showBtn.split(",").map(Number);
            }
            this.list.push(temp);
          }
          if (this.page * this.size >= this.total) {
            // 数据全部加载完成, 接口返回的totalPage为空, 采用另一种方法判断
            this.finished = true;
          }
          // 加载状态结束
          this.loading = false;
        });
    },
    onSearch: function () {
      // 搜索时重置页数和数据
      this.page = 0;
      this.list = [];
      // 需要重置finished值
      this.finished = false;
      // 加载数据
      this.loadData();
    },
    onBtnClick: function (type, id, cBqid, nBqlx) {
      sessionStorage.setItem("nBqlx", nBqlx);
      if (type === this.btnType.BJ_BUTTON) {
        // 编辑
        this.$router.push({
          path: "/relievePreservationNew",
          query: {
            // bqid: id,
            // sqbh: cSqbh,
            cId: id,
            bqid: cBqid,
          },
        });
        return;
      }
      if (type === this.btnType.SC_BUTTON) {
        // 删除
        Dialog.confirm({
          title: "提示",
          message: "确认删除吗？删除后不可恢复",
          confirmButtonColor: "#ffffff",
          cancelButtonColor: "#ffffff",
        })
          .then(() => {
            this.$axios
              .delete("ssbq/api/ssbq/jc/delete?id=" + id)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    message: "删除成功",
                    type: "success",
                  });
                  this.page = 0;
                  this.list = [];
                  this.loadData();
                }
              });
          })
          .catch(() => {});
        return;
      }
      // 重新申请复议
      if (type === btnType.CXSQFY_BUTTON) {
        this.$axios.get("ssbq/api/fy/cxsqfy?fyid=" + id).then((res) => {
          if (res.code == 200) {
            // 跳转到复议申请页面
            this.$router.push(`/applyReconsider?id=${id}`);
          } else {
            this.$notify(res.message);
            return;
          }
        });
        return;
      }
    },
    //点击导航
    changeNav(navIndex) {
      this.active = navIndex;
    },
  },
  created() {
    this.getCode811000();
    this.loadData();
  }
};
</script>
